import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "grid",
  "use": "grid-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"grid\"><path stroke=\"currentColor\" d=\"M.417.75h4.722v4.722H.417zm7.777 0h4.722v12.5H8.194zM.417 8.527h4.722v4.722H.417z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol